module.exports = __webpack_public_path__ + "static/media/public.jwt.a578fad7.pem";